import {SpecialVaccine, Vaccine} from '@clinical/forms/interfaces/special-vaccines.interface';
import {SPECIAL_VACCINES} from '@clinical/forms/constants/special-vaccines.const';
import {DateService} from '@shared/services/date.service';
import {format} from 'date-fns';

const vaccinesContent = (row: any) => SPECIAL_VACCINES.map((vaccine: Vaccine) => {
  const vaccineSelected: Vaccine = !row.vaccines
    ? false
    : row.vaccines.find((selectVaccine: Vaccine) => selectVaccine.id === vaccine.id);
  return [
    {text: vaccineSelected ? 'X' : '', alignment: 'center', fontSize : 8},
    {text: [{text: vaccine?.id === 19 ? ` ${vaccineSelected?.name || 'Otras'}` : vaccine?.name}], fontSize : 8},
    {text: vaccineSelected ? vaccineSelected.quantity : '', alignment: 'center', fontSize : 8},
    {text: vaccineSelected ? vaccineSelected.observations : '', fontSize : 8},
  ];
});

const formattedDate = (date: string): string => {
  if (!date) return '';
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);
  return format(newDate, 'dd-MM-yyyy');
};

export const buildContentPdfSpecialVaccines = (paperwork, group) => {
  const {rows} = group;
  const {patient} = paperwork;

  const vacBuildPdf = rows.map((item: SpecialVaccine) => {
    const thTextColor = '#fff';
    const thFillColor = '#4f81ba';
    const {region, commune, establishment, pathologicalCondition, pharmaceuticalTreatment, date} = item;

    return [
      {
        table : {
          widths    : ['*', '*'],
          headerRows: 2,
          body      : [
            [{
              text     : 'DATOS DEL ESTABLECIMIENTO',
              color    : thTextColor,
              fillColor: thFillColor,
              bold     : true,
              colSpan  : 2,
              alignment: 'center',
              fontSize : 8,
            }, {}],
            [
              {
                text: [{text: `Región: `, bold: true, fontSize : 8}, {text: `${!region ? '' : region}`, fontSize : 8}],
              },
              {
                text: [{text: `Comuna: `, bold: true, fontSize : 8}, {text: `${commune}`, fontSize : 8}],
              },
            ],
            [
              {
                text   : [{text: `Establecimiento: `, bold: true, fontSize : 8}, {text: `${establishment}`, fontSize : 8}],
                colSpan: 2,
              },
              {},
            ],
            [
              {
                text   : [{text: `Fecha solicitud: `, bold: true, fontSize : 8}, {text: formattedDate(date), fontSize : 8}],
                colSpan: 2,
              },
              {},
            ],
          ],
        },
        margin: [0, 0, 0, 0],
      },
      {
        table : {
          widths    : ['*', '*'],
          headerRows: 2,
          body      : [
            [{
              text     : 'DATOS DEL PACIENTE',
              color    : thTextColor,
              fillColor: thFillColor,
              bold     : true,
              colSpan  : 2,
              alignment: 'center',
              fontSize : 8
            }, {}],
            [
              {
                text   : [
                  {text: `Nombre completo: `, bold: true, fontSize : 8},
                  {text: `${!patient ? '' : patient.names} ${!patient ? '' : patient.surnames}`, fontSize : 8},
                ],
                colSpan: 2,
              },
              {},
            ],
            [
              {
                text: [{
                  text: `Rut /DNI /Pasaporte: `,
                  bold: true,
                  fontSize : 8,
                }, {text: `${!patient ? '' : patient.documentNumber}`, fontSize : 8}],
              },
              {
                text: [
                  {text: `Fecha de Nacimiento: `, bold: true, fontSize : 8},
                  {text: `${!patient ? '' : formattedDate(patient.birth)}`, fontSize : 8},
                ],
              },
            ],
            [
              {
                text: [{text: `Edad: `, bold: true, fontSize : 8},
                  {text: `${!patient ? '' : DateService.yearsOld(patient.birth)}`, fontSize : 8}],
              },
              {
                text: [{text: `Sexo Biológico: `, bold: true, fontSize : 8},
                  {text: `${!patient ? 'M ( )	F ( )	Otro ( )' : (patient.gender || '').slice(0, 1)}`, fontSize : 8}],
              },
            ],
            [
              {
                text   : [
                  {text: `Diagnóstico Clínico: `, bold: true, fontSize : 8},
                  {text: `${pathologicalCondition || ''}`, fontSize : 8},
                ],
                colSpan: 2,
              },
              {},
            ],
            [
              {
                text   : [
                  {
                    text: [{
                      text: `Tratamiento farmacológico:`,
                      bold: true,
                      fontSize : 8,
                    }, {text: `\n(Nombre de medicamento y dosis) `, fontSize : 8}],
                  },
                  {text: `${pharmaceuticalTreatment || ''}`, fontSize : 8}],
                colSpan: 2,
              },
              {},
            ],
          ],
        },
        margin: [0, 10, 0, 10],
      },
      {
        table: {
          widths: [60, 100, 70, '*'],
          body  : [
            [
              {
                text     : 'Marcar Vacuna (X)',
                color    : thTextColor,
                fillColor: thFillColor,
                bold     : true,
                style    : 'tableHeader',
                fontSize : 8,
              },
              {
                text     : 'Vacuna (s) Solicitada(s)',
                color    : thTextColor,
                fillColor: thFillColor,
                bold     : true,
                style    : 'tableHeader',
                fontSize : 8,
              },
              {
                text     : 'Nº dosis Solicitadas',
                color    : thTextColor,
                fillColor: thFillColor,
                bold     : true,
                style    : 'tableHeader',
                fontSize : 8,
              },
              {text: 'Observaciones', color: thTextColor, fillColor: thFillColor, bold: true, style: 'tableHeader', fontSize : 8},
            ],
            ...(vaccinesContent(item)),
          ],
        },
      },
      {
        text     : [
          {text: 'IMPORTANTE:', bold: true, fontSize : 8},
          {text: ' Recuerde adjuntar Orden médica, Epicrisis o Historia clínica y Notificación ESAVI si corresponde.', fontSize : 8},
        ],
        alignment: 'justify',
        margin   : [0, 5],
      },
    ];
  });

  return [vacBuildPdf];
};
